import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  class: "dropdown-toggle centered fs12 w100",
  style: {"background-color":"transparent","border":"none","appearance":"none","padding":"0","outline":"none"}
}
const _hoisted_3 = {
  class: "fs12 pad10 mt10 hoverWhiteBg",
  style: {"width":"200px"}
}
const _hoisted_4 = { class: "fs12 fw600" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "fs11" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4"
}, "ユーザー設定", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4"
}, "カレンダー共有", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4"
}, "メンバー設定", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4"
}, "企業設定", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = { key: 4 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", {
  role: "separator",
  class: "divider"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "fs10 fw600 ml10" }, "ユーザーグループ切り替え", -1)
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  role: "button",
  class: "fl mr4"
}
const _hoisted_26 = { class: "fs12" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "fs10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("li", {
  role: "separator",
  class: "divider"
}, null, -1)
const _hoisted_32 = {
  class: "logout centered fl w100",
  id: "logout-button",
  style: {"line-height":"30px","padding":"2px"},
  rel: "nofollow",
  "data-method": "delete",
  href: "/users/sign_out"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs12 mt2" }, "ログアウト", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.rm && _ctx.rm.userInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dropdown, {
          "append-to-body": "",
          class: _normalizeClass(`dropdown`),
          id: "userIconMenu"
        }, {
          dropdown: _withCtx(() => [
            _createElementVNode("li", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.rm.userInfo.name), 1),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.rm.userInfo.email), 1),
              _hoisted_7
            ]),
            (!_ctx.isSP)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goUserSettings && _ctx.goUserSettings(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/user_black.png`),
                    width: "21",
                    height: "22",
                    class: "fl mr5 mt2"
                  }, null, 8, _hoisted_8),
                  _hoisted_9,
                  _hoisted_10
                ]))
              : _createCommentVNode("", true),
            (_ctx.showShareCalPage())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goShareCalendar && _ctx.goShareCalendar(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/calendar_share.png`),
                    width: "21",
                    height: "20",
                    class: "fl mr5 mt4 ml1"
                  }, null, 8, _hoisted_11),
                  _hoisted_12,
                  _hoisted_13
                ]))
              : _createCommentVNode("", true),
            (_ctx.showRoomMembers())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goMembersSettings && _ctx.goMembersSettings(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                    width: "22",
                    height: "16",
                    class: "fl mr5 mt4"
                  }, null, 8, _hoisted_14),
                  _hoisted_15,
                  _hoisted_16
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAccountPage())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goAccountSettings && _ctx.goAccountSettings(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/organizations.png`),
                    width: "21",
                    height: "21",
                    class: "fl mr5 mt2"
                  }, null, 8, _hoisted_17),
                  _hoisted_18,
                  _hoisted_19
                ]))
              : _createCommentVNode("", true),
            (_ctx.changeableUserGroups.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.changeableUserGroups, (ug, ugindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "fs12 pointer pad10",
                      style: {"width":"200px"},
                      onClick: ($event: any) => (_ctx.changeUg(ug)),
                      key: ugindex
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/organizations.png`),
                        width: "21",
                        height: "21",
                        class: "fl mr5 mt2"
                      }, null, 8, _hoisted_24),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(ug.company_name), 1),
                        _hoisted_27,
                        _createElementVNode("span", _hoisted_28, "（" + _toDisplayString(ug.namespace) + "）", 1),
                        _hoisted_29
                      ]),
                      _hoisted_30
                    ], 8, _hoisted_23))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_31,
            _createElementVNode("li", {
              class: "fs12 pointer fw600 pad10",
              style: {"line-height":"40px","width":"200px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickLoggedOutButton && _ctx.clickLoggedOutButton(...args)))
            }, [
              _createElementVNode("a", _hoisted_32, [
                _createElementVNode("img", {
                  class: "fl mr5",
                  src: _ctx.$getAssetImageUrl(`/assets/icons/logout_icon.png`),
                  width: "18",
                  height: "18"
                }, null, 8, _hoisted_33),
                _hoisted_34,
                _hoisted_35
              ]),
              _hoisted_36
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("li", _hoisted_2, [
              _createVNode(_component_UserIcon, {
                member: _ctx.rm.userInfo,
                width: _ctx.isSP ? 38 : 45,
                canEdit: false,
                updateSelf: false,
                showTooltip: false,
                class: _normalizeClass(`pointer ${_ctx.isSP ? `mt2` : `hoverWhiteBorder`}`),
                style: _normalizeStyle(`border-radius: 50%; ${
                        _ctx.isSP ? `width:39px;height:39px;` : `width: 51px; height: 51px; margin: 0 auto`
                    }`)
              }, null, 8, ["member", "width", "class", "style"])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}